import { useQuery } from "@tanstack/react-query"
import api from "../../http"

export const useGetMe = (
    forBindingParams: { forBinding: string } | Record<string, never> = {},
    options: { enabled?: boolean; retry?: number | boolean } = {}
) => {
    return useQuery({
        queryKey: ['me', (forBindingParams as { forBinding?: string }).forBinding ?? null],
        enabled: options.enabled,
        retry: options.retry,
        queryFn: async () => {
            const { data } = await api.get('/user/get', { params: forBindingParams });
            return data;
        }
    });
}